import React from "react"
import Layout from "../../components/Layout/Layout"
import Seo from 'gatsby-plugin-wpgraphql-seo';
import { graphql } from 'gatsby'
import BannerPagina from "../../components/Banner/BannerPagina"
import Contenido from "../../components/Parrafo/Contenido"
import { Helmet } from "react-helmet"

export const query = graphql`
  query($id: ID!) {
    pionero {
      page(id: $id, idType: DATABASE_ID) {
        title
        uri
        slug
        
        seo {
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphTitle
          opengraphDescription
          opengraphImage {
              altText
              sourceUrl
              srcSet
          }
          twitterTitle
          twitterDescription
          twitterImage {
              altText
              sourceUrl
              srcSet
          }
          canonical
          cornerstone
          schema {
              articleType
              pageType
              raw
          }
        }
        
        terminos_y_condiciones {
          bannerTitulo
          bannerColorFondo
          bannerImagenFondo {
            altText
            srcSet
            sourceUrl
            title
            sourceUrlSharp {
              childImageSharp {
                gatsbyImageData(
                  formats: [AUTO, WEBP]
                  placeholder: NONE
                )
              }
            }
          }
          contenido
        }
      }
    }
  }
`

export default function Terminos_condiciones({ data }) {
  const page = data.pionero.page;

  (typeof window !== `undefined`) && document.documentElement.style.setProperty('--color-pagina', page.terminos_y_condiciones.bannerColorFondo);
  (typeof window !== `undefined`) && document.documentElement.style.setProperty('--color-texto', '#2D2D2D');

  return (
    <Layout>
      <Helmet>
        <link rel="canonical" href={page.seo.canonical} />
      </Helmet>
      <Seo post={page} />
      <h1 className="none">{page.title}</h1>
      <BannerPagina
        titulo={page.terminos_y_condiciones.bannerTitulo}
        fondoColor={page.terminos_y_condiciones.bannerColorFondo}
        imagen={page.terminos_y_condiciones.bannerImagenFondo}
      />
      <Contenido
        contenido={page.terminos_y_condiciones.contenido}
      />
    </Layout>
  )
}